import React from 'react';
import {
  CompanyFileDocumentType,
  ConnectorType,
  ConnectorSource,
  FinancialDocumentTaskStates,
} from '@hum/types';
import { renderDate } from './File';
import {
  Button,
  ButtonType,
  Icon,
  ProgressDownload,
  Text,
  TextType,
} from '@hum/ui-library';
import { useDownloadFinancialDocuments } from '@hum/icm-app/src/hooks/useDownloadFinancialDocuments';

export type FinancialModelFileProps = {
  companyId: string;
  docType: CompanyFileDocumentType;
  docTitle: string;
  lastSuccessPullAt?: string;
  isDownloadingFile: boolean;
  connectorType?: ConnectorType;
  connectorSource?: ConnectorSource;
};

export const FinancialModelFile = ({
  companyId,
  docType,
  docTitle,
  lastSuccessPullAt,
  connectorType,
  connectorSource,
}: FinancialModelFileProps) => {
  const date = lastSuccessPullAt ? new Date(lastSuccessPullAt) : new Date();

  const {
    handleDownloadFinancialDocuments,
    isPolling,
    isError,
    stopDownload,
    task,
  } = useDownloadFinancialDocuments({
    companyId,
    docType,
    connectorType,
    connectorSource,
  });
  const isFailure =
    isError || task?.state === FinancialDocumentTaskStates.Failure;
  const isSuccess = task?.state === FinancialDocumentTaskStates.Success;

  return (
    <div>
      <li className="flex items-center p-4 select-none hover:bg-gray-700">
        <Icon.DefaultFile className="mr-4" />
        <Text
          type={TextType.UI_ELEMENT}
          className="flex-1 w-[200px] xl:w-full truncate"
          forceCapitalization={false}
        >
          {docTitle}
        </Text>
        <Text
          type={TextType.BODY_MICO}
          subdued
          className="hidden mr-6 xl:block"
        >
          Hum Capital
        </Text>
        <Text
          type={TextType.BODY_MICO}
          subdued
          className="hidden mr-6 xl:block"
        >
          {renderDate(date.toString())}
        </Text>
        <Button
          type={ButtonType.QUIET}
          testId={`dataroom:financial-model-file-${docType}`}
          disabled={isPolling}
          onClick={handleDownloadFinancialDocuments}
        >
          <Icon.Download className="mr-2" />
        </Button>
      </li>
      <ProgressDownload
        onCancel={stopDownload}
        isPolling={isPolling}
        isFailure={isFailure}
        isSuccess={isSuccess}
      />
    </div>
  );
};
